import React from 'react';
import useTariffApproval from '../../hooks/useTariffApproval';
import GeneralMessage from '../../components/UI/GeneralMessage';
import TariffContentList from '../../modules/tariff/TariffContentList';
import Grid from '../../components/UI/Grid/Grid';

const TariffApproval = props => {
    const {
        pendingTariffHeaders,
        pendingTariffContentHeaders,
        pendingTariffGridData,
        approveTariffHandler,
        rejectTariffHandler,
        onRowToggle,
        selectedTariffRow,
        generalErrorList,
        successMessage,
    } = useTariffApproval();

    const rowExpansionTemplate = data => {
        return (
            <div className="container-fluid card p-4 mb-5 animated fadeIn">
                <div className="row">
                    <div className="col-12 mb-3">
                        <Grid data={data.content} columns={pendingTariffContentHeaders} />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <GeneralMessage
                className="c-msg"
                successMessage={successMessage}
                errorList={generalErrorList}
            />
            <TariffContentList
                rowExpansionTemplate={rowExpansionTemplate}
                listTitle="Pending Tariff"
                gridHeaders={pendingTariffHeaders}
                gridData={pendingTariffGridData}
                expandTable={true}
                approveAction={approveTariffHandler}
                rejectAction={rejectTariffHandler}
                onRowToggle={onRowToggle}
                selectedRow={selectedTariffRow}
                expandDataKey="id"
            />
        </>
    );
};

export default TariffApproval;
